import React, { useState } from 'react';
import { translate } from '../../Services/translation';

const GdprAccordion = (props) => {
    const [isAccordionActive, setAccordionActive] = useState(false);
    const [agreeToTracking, setAgreeToTracking] = useState(props?.accepted);

    const handleChange = () => {
        setAgreeToTracking(!agreeToTracking);
        props.onToggledThing(!agreeToTracking);
    };

    return (
        <div className="gdpr-accordion-item">
            <div className="gdpr-accordion-title" onClick={() => setAccordionActive(!isAccordionActive)}>
                <div>
                    <strong className='mr-2'>{isAccordionActive ? '-' : '+'}</strong>
                    <strong>{props.title}</strong>
                </div>
                {props.optional &&
                    <div>
                        <label className="custom-switch">
                            <input type="checkbox" checked={agreeToTracking} onChange={handleChange} />
                            <span className="custom-slider-switch custom-switch-round"></span>
                        </label>
                    </div>
                }
            </div>
            {isAccordionActive &&
                <div className="gdpr-accordion-content">
                    {props.content}
                    {props.trackingServices != null &&
                        <div className='gdpr-tracking-services'>
                            <h4>{translate("cookie.used.services.text")}</h4>
                            <div className='gdpr-tracking-services-content'>
                                <p>
                                    {props.trackingServices.header}
                                </p>
                                <a href={props.trackingServices.link} className="simple-link-underline">
                                    {translate("cookie.go.to.policy.text")}
                                </a>
                            </div>
                        </div>
                    }
                </div>
            }
        </div>
    );
};

export default GdprAccordion;